import { BRIDGE_CALLBACKS } from './voltBridge.constants';
import type {
  BridgeCallbackName,
  RedirectCallback,
  RedirectResult,
  StatusToResultMap,
} from './voltBridge.types';

function isFunction(property: unknown): boolean {
  return typeof property === 'function';
}

type VoltBridgeWindow = Window &
  typeof globalThis & {
    [K in BridgeCallbackName]?: RedirectCallback;
  };

const getVoltBridgeWindow = () => window as VoltBridgeWindow;

export const getVoltBridgeCallback = (callbackName: BridgeCallbackName) =>
  getVoltBridgeWindow()[callbackName];

export const isRedirectCallbackDefined = () =>
  BRIDGE_CALLBACKS.some((redirectCallback) =>
    isFunction(getVoltBridgeCallback(redirectCallback))
  );

export const getRedirectCallbackName = () =>
  BRIDGE_CALLBACKS.find((redirectCallback) =>
    isFunction(getVoltBridgeCallback(redirectCallback))
  );

export function isMappedStatus<T extends string>(
  status: string | undefined,
  map: StatusToResultMap<T>
): status is T {
  return status !== undefined && status in map;
}

export function getRedirectResult<T extends string>(
  status: string | undefined,
  map: StatusToResultMap<T>,
  onInvalidStatus?: (status: string | undefined) => void
): RedirectResult {
  if (isMappedStatus(status, map)) {
    return map[status] ?? 'exception';
  }

  onInvalidStatus?.(status);

  return 'exception';
}
